import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip'

type Props = {
    children: React.ReactNode
    content: React.ReactNode
    className?: string
    style?: React.CSSProperties
    side?: 'top' | 'right' | 'bottom' | 'left'
}

const TooltipWrapper = ({ children, content, className, style, side }: Props) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent side={side}>
                    <div className={`max-w-[300px] ${className}`} style={style}>
                        {content}
                    </div>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}

export default TooltipWrapper
